import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreTimelineSummaryGetAsyncSlice } from './get';

export const coreLegacyTimelineSummaryReducers = combineReducers({
	get: coreTimelineSummaryGetAsyncSlice.asyncReducers
});

export const coreLegacyTimelineSummaryWatchers = combineAllWatchers([ coreTimelineSummaryGetAsyncSlice.asyncWatchers ]);
